import Vue from 'vue';
import Router from 'vue-router';

import login from '@/views/login';
import WalletCenter from '@/views/WalletCenter';
import BankCards from '@/views/BankCards';
import Recharge from '@/views/Recharge';
import Setting from '@/views/Setting';
import Withdraw from '@/views/Withdraw';
import Pay from '@/views/Pay';
import PayStatus from '@/views/PayStatus';
import Status from '@/views/Status';
import Fail from '@/views/Fail';
import Record from '@/views/Record';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'WalletCenter',
      component: WalletCenter
    },
    {
      path: '/main',
      name: 'main',
      component: WalletCenter
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },

    { // 用户协议
      path: '/protocol',
      name: 'protocol',
      component: () => import('../views/protocol.vue')
    },

    ///////////////////////////////////

    { // 登录后未绑定/创建钱包前的过渡页
      path:   '/createGateway',
      name:   'createGateway',
      component:  () => import('../views/createGateway.vue')
    },

    { // 创建钱包
      path:   '/createWallet',
      name:   'createWallet',
      component:  () => import('../views/createWallet.vue')
    },

    { // 绑定钱包
      path:   '/bind',
      name:   'bind',
      component:  () => import('../views/bind.vue')
    },

    { // 绑定成功
      path:   '/success',
      name:   'success',
      component:  () => import('../views/success.vue')
    },

    ///////////////////////////////////

    {
      path: '/bank_cards',
      name: 'BankCards',
      component: BankCards
    },
    {
      path: '/bank_cards/:wallet_id',
      component: BankCards
    },
    {
      path: '/recharge',
      name: 'Recharge',
      component: Recharge
    },
    {
      path: '/recharge/:wallet_id',
      component: Recharge
    },
    {
      path: '/setting',
      name: 'Setting',
      component: Setting
    },
    {
      path: '/setting/:wallet_id',
      component: Setting
    },
    {
      path: '/Withdraw',
      name: 'Withdraw',
      component: Withdraw
    },
    {
      path: '/Withdraw/:wallet_id',
      component: Withdraw
    },
    {
      path: '/Pay',
      name: 'Pay',
      component: Pay
    },
    {
      path: '/PayStatus',
      name: 'PayStatus',
      component: PayStatus
    },
    {
      path: '/Fail',
      name: 'Fail',
      component: Fail
    },
    {
      path: '/Record',
      name: 'Record',
      component: Record
    },
    {
      path: '/Record/:wallet_id',
      component: Record
    },
    {
      path: '/Status',
      name: 'Status',
      component: Status
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js